import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {KeyboardDatePicker, MuiPickersUtilsProvider,} from '@material-ui/pickers';
import { InstyleButton } from '../components/Page/Page';
import moment from 'moment';
import { queueService } from '../services';
import CircularProgress from '@material-ui/core/CircularProgress';
import CallAttemptAccordion from '../components/Reports/CallAttemptAccordion';
import Plot from 'react-plotly.js';

export const CallAttemptsPath = "/call-attempts";
export default function CallAttemptsPage(props) {
    const dateFormat = 'yyyy-MM-dd';
    const momentFormat = 'YYYY-MM-DD'
    const [start, setStart] = React.useState(new Date().setDate(new Date().getDate() - 7));
    const [end, setEnd] = React.useState(new Date())
    const [runDisabled, setRunDisabled] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [callData, setCallData] = React.useState([]);

    const handleStartChange = (date) => {
        setStart(date);
    };

    const handleEndChange = (date) => {
        setEnd(date);
    };

    const runReport = () => {
        let s = moment(start).format(momentFormat);
        let e = moment(end).format(momentFormat);
        let newStart = s;
        let newEnd = e;
        if (s === e) {
            alert('start and end date should be different');
            return
        }
        //swap the values incase someone does something funny
        if (new Date(s).getTime() > new Date(e).getTime()) {
            newStart = e;
            newEnd = s;
        }
        setRunDisabled(true);
        setLoading(true);
        queueService.getCallAttemptData(newStart, newEnd).then(resp => {
            setRunDisabled(false);
            setLoading(false);
            setCallData(resp.Data);
        })
        .catch(e => {
            setRunDisabled(false);
            setLoading(false);
            alert(e);
        })

    }

    if (loading) {
        return (
            <div style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <CircularProgress />
            </div>
        )
    }

    const addedToDialer = callData.map(cd => {
        return cd.AddedTime !== '' ? cd : null;
    }).filter(i => i)

    const attemptMade = callData.map(cd => {
        return cd.AttemptTime !== '' ? cd : null;
    }).filter(i => i)

    const contactMade = callData.map(cd => {
        return cd.ContactTime !== '' ?cd : null;
    }).filter(i => i)

    //work out the average time to add to the dialler
    let addedToDialerTimes = addedToDialer.map(cd => {
        let created = moment(cd.CreatedTime);
        let added = moment(cd.AddedTime);
        let ms = Math.abs(created.diff(added));
        const d = moment.duration(ms)
        return d.asMinutes()
    })

    let firstContactTimesTimes = attemptMade.map(cd => {
        let created = moment(cd.AddedTimeBusiness);
        let added = moment(cd.AttemptTime);
        let ms = Math.abs(created.diff(added));
        const d = moment.duration(ms)
        return d.asMinutes()
    }).filter(i => i)

    let madeContactTimesTimes = contactMade.map(cd => {
        let created = moment(cd.AddedTimeBusiness);
        let added = moment(cd.ContactTime);
        let ms = Math.abs(created.diff(added));
        const d = moment.duration(ms)
        return d.asMinutes()
    }).filter(i => i)

    return (
        <div style={{padding: '16px'}}>
            <h1 style={{fontFamily: "Ink", textAlign: "center", padding: "20px"}}>Call Attempts</h1>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <KeyboardDatePicker
                    format={dateFormat}
                    margin="normal"
                    label="Start Date"
                    value={start}
                    onChange={handleStartChange}
                    />
                    <div style={{display: 'inline-block'}}>&nbsp; - &nbsp;</div>
                    <KeyboardDatePicker
                    format={dateFormat}
                    margin="normal"
                    label="End Date"
                    value={end}
                    onChange={handleEndChange}
                    />
                    <div>
                        <InstyleButton disabled={runDisabled} onClick={runReport}>Run Report</InstyleButton>
                    </div>
                </div>
            </MuiPickersUtilsProvider>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', marginTop: '20px'}}>
                {/* calls boxes */}
                <div className={'call-attempt--box'}>
                    Total Calls
                    <div>{callData.length}</div>
                </div>
                <div className={'call-attempt--box'}>
                    ADDED TO DIALLER
                    <div>
                        {
                            addedToDialer.length
                        } / {callData.length}
                    </div>
                    <div>
                        Avg Time: {(addedToDialerTimes.reduce((total, current) => total += current, 0) / addedToDialer.length).toFixed(2)} Minutes
                    </div>
                </div>
                <div className={'call-attempt--box'}>
                    FIRST ATTEMPT
                    <div>
                        {
                            attemptMade.length
                        } / {addedToDialer.length}
                    </div>
                    <div>
                        Avg Time: {(firstContactTimesTimes.reduce((total, current) => total += current, 0) / attemptMade.length).toFixed(2)} Minutes
                    </div>
                </div>
                <div className={'call-attempt--box'}>
                    Contact made
                    <div>
                        {contactMade.length} / {attemptMade.length}
                    </div>
                    <div>
                        Avg Time: {(madeContactTimesTimes.reduce((total, current) => total += current, 0) / contactMade.length).toFixed(2)} Minutes
                    </div>
                </div>
            </div>
            <div>
                <CallAttemptAccordion title="Deals with No First Attempt" items={callData.map(cd => {
                    return cd.FirstAttempt === '' ? cd : null;
                }).filter(i => i)}
                note={`Many reasons can cause a call to not be made.  Most common is bad sales areas, sales areas not configured or assigned person has not worked.`}
                />
                <CallAttemptAccordion title="Deals with No Contact Made" items={callData.map(cd => {
                    return cd.ContactMade === '' ? cd : null;
                }).filter(i => i)}
                note={`Many reasons can cause a call to not be made.  Most common is bad phone numbers as an attempt to call them has been made.`}
                />
            </div>
        </div>
    )
}
